import React from 'react'

const Footer = () => <footer>
    SERAEBEN©2024 // POWERED BY <i className='fab fa-react' />
    </footer>

export default Footer
